import { Component } from '@verndale/core';
import { LoadSequence } from '../helpers/animations';

class SimpleMasthead extends Component {
  setupDefaults() {
    this.loadAnimation();
  }

  loadAnimation() {
    LoadSequence(this.el, [{ element: this.el, addScale: false, offset: 0 }]);
  }
}

export default SimpleMasthead;
